import * as React from 'react';



export default class check extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 12 12" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" onClick={this.props.onClick}>
        <g id="caption-tick-icon" stroke="" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g id="Group-34" stroke="">
                <g transform="translate(0.000000, 2.000000)">
                    <polyline id="Path-7" transform="translate(6.166321, 4.128476) rotate(-6.000000) translate(-6.166321, -4.128476) " points="1.16632052 3.3600013 3.63456304 6.94043599 11.1663205 1.31651657"></polyline>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
